import brandit_rails from '../../../../api/brandit_rails'
import { setLocationsStatusAction, setLocationsErrorsAction, setLocationOptionsAction } from './locations.actions'

/**
 * Fetch lightweight location options for dropdowns
 * @param {Object} options - Query parameters
 * @param {number} [options.portal_id] - Filter locations by portal ID
 * @param {number} [options.client_id] - Filter locations by client ID
 * @param {string} [options.search] - Search locations by name
 */
export const fetchLocationOptions =
  (options = {}) =>
  async dispatch => {
    try {
      dispatch(setLocationsStatusAction('loading'))

      const { data } = await brandit_rails.request({
        url: '/location_options',
        method: 'GET',
        params: options
      })

      dispatch(setLocationOptionsAction(data))
      dispatch(setLocationsStatusAction('succeeded'))
      return data
    } catch (err) {
      dispatch(setLocationsErrorsAction(err.response?.data || err.message))
      dispatch(setLocationsStatusAction('failed'))
      throw err
    }
  }
